import React from "react";
import { get } from "lodash";
import formatCurrency from "@tvg/formatter/currency";
import { BetSelection } from "@tvg/ts-types/Bet";
import { getWillPaysSimpleRace } from "@tvg/sh-lib-my-bets/utils/runnerNumberGroupUtils";
import { WillPays } from "../styled-components";

export interface WillPaysDetailsProps {
  runner: BetSelection;
  payoutsTitles?: string[];
  runnerNumber: string;
  payoutsTitlesLength: number;
}

const WillPaysDetails = ({
  payoutsTitles,
  runner,
  runnerNumber,
  payoutsTitlesLength
}: WillPaysDetailsProps) => (
  <>
    {getWillPaysSimpleRace(runner, payoutsTitles).map((amount) => (
      <WillPays
        key={`${runnerNumber}-${get(runner, "willPayAmount", "")}-willPays`}
        hasMargin={payoutsTitlesLength < 3}
      >
        {typeof amount === "number" &&
          amount > 0 &&
          formatCurrency(amount, "USD")}
      </WillPays>
    ))}
  </>
);

export default WillPaysDetails;
